export var EKeysMap;
(function (EKeysMap) {
  EKeysMap["BACKSPACE"] = "Backspace";
  EKeysMap["DELETE"] = "Delete";
})(EKeysMap || (EKeysMap = {}));